import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';
import RSVP from 'rsvp';

class PlanningDashboardCapacityRoute extends Route {
  @service store;
  @service router;

  beforeModel() {
    this.router.on('routeDidChange', this.redirectToInnerPage);
    this.router.on('routeWillChange', this.blockInnerToParentPage);
  }

  redirectToInnerPage = (transition) => {
    if (transition?.to?.name === 'planning.dashboard.capacity.index')
      this.router.transitionTo('planning.dashboard.capacity.teams');
  };

  blockInnerToParentPage = (transition) => {
    if (
      transition?.to?.name === 'planning.dashboard.capacity.index' &&
      [
        'planning.dashboard.capacity.weeks',
        'planning.dashboard.capacity.roles',
        'planning.dashboard.capacity.teams',
      ].includes(transition?.from?.name)
    )
      transition.abort();
  };

  model() {
    return RSVP.hash({
      roadmap: this.modelFor('planning.dashboard'),
      teams: this.store.query('team', {
        filter: {
          active: true,
        },
      }),
      roles: this.store.findAll('role'),
    });
  }

  resetController(controller, isExiting, transition) {
    if (isExiting && transition.targetName !== 'error') {
      this.router.off('routeDidChange', this.redirectToInnerPage);
      this.router.off('routeWillChange', this.blockInnerToParentPage);
    }
  }
}

export default instrumentRoutePerformance(PlanningDashboardCapacityRoute);
